import React from 'react'
import { SVG, Rect } from '@wordpress/components'

export const SliderIcon = (
  <SVG viewBox={[0, 0, 64, 64].join(' ')} xmlns="http://www.w3.org/2000/svg">
    {/* <Rect
      x="8"
      y="17"
      width="48"
      height="30"
      rx="2"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="4"
    /> */}

    <Rect
      x="-22"
      y="20"
      width="30"
      height="24"
      rx="2"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="4"
    />

    <Rect
      x="56"
      y="20"
      width="30"
      height="24"
      rx="2"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="4"
    />

    <Rect
      x="17"
      y="17"
      width="30"
      height="30"
      rx="2"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="4"
    />
  </SVG>
)

export const SlideIcon = (
  <SVG viewBox={[0, 0, 64, 64].join(' ')} xmlns="http://www.w3.org/2000/svg">
    {/* <Rect
      x="8"
      y="17"
      width="48"
      height="30"
      rx="2"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="4"
    /> */}

    <Rect
      x="-22"
      y="20"
      width="30"
      height="24"
      rx="2"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="4"
    />

    <Rect
      x="56"
      y="20"
      width="30"
      height="24"
      rx="2"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="4"
    />

    <Rect
      x="17"
      y="17"
      width="30"
      height="30"
      rx="2"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="4"
    />
  </SVG>
)
